import { Theme } from './Theme';
import { themeBase } from './themeBase';
const themeDefaultColors = {
    foreground: '#12161E',
    background: '#FFFFFF',
    body: '#FCFCFC',
    primary: '#4575CD',
    secondary: '#575A64',
    success: '#44B48B',
    warning: '#F3BE34',
    danger: '#D62B20',
    colors: {},
};
export const themeDefault = new Theme({
    name: 'Default',
    ...themeDefaultColors,
    style: themeBase,
});
//# sourceMappingURL=themeDefault.js.map